import { HttpClient, HttpEventType, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { Material } from '../../../warehouse/material/material';
import { Supplier } from '../../../warehouse/supplier/supplier';
import {
    defaultKfzSachkonto,
    FIBU_HONORAR_KOSTENARTEN,
    FIBU_KOSTENARTEN,
    FIBU_MWST_SAETZE,
    Gemeinkosten,
    GemeinkostenPosition,
    GemeinkostenPreise,
    kfzSachkontoFromArtikel,
    kfzSuffixForFahrzeug,
    nettoFromBrutto,
    normalizeMwstSatz,
    preferredAufwandKontoNr,
    kfzKontoNr,
    mwstEuroForTargetBrutto,
    roundEuro2,
} from '../gemeinkosten';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Tierarzt } from '../../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { NebenkostenArtikelPickerDialogComponent } from '../gemeinkosten-invoice-review/nebenkosten-artikel-picker-dialog.component';

@Component({
    selector: 'kiene-gemeinkosten-details-dialog',
    templateUrl: './gemeinkosten-details-dialog.component.html',
    styleUrls: ['./gemeinkosten-details-dialog.component.css'],
})
export class GemeinkostenDetailsDialogComponent implements OnInit {
    @ViewChild('fileSelector') fileSelector;
    filesToUpload: File[] = [];
    filesProgressValues: number[] = [];
    filesUploadStatus: number[] = [];

    gemeinkosten = new Gemeinkosten();

    material: Material;
    supplier: Supplier;

    artikelParams: HttpParams;
    lieferantParams = new HttpParams().set('nebenkosten', '1');
    fahrzeugParams = new HttpParams().set('aktiv', '1');
    honorarTaParams = new HttpParams().set('aktiv', '1');

    gemeinkostenTypCtrl = new FormControl();
    datumCtrl = new FormControl();
    kommentarCtrl = new FormControl('');
    rechnungNummerCtrl = new FormControl('');
    leistungsdatumVonCtrl = new FormControl();
    leistungsdatumBisCtrl = new FormControl();

    tierarzt: Tierarzt;
    nurHonorar = false;
    get kostenarten() {
        return this.nurHonorar ? FIBU_HONORAR_KOSTENARTEN : FIBU_KOSTENARTEN;
    }
    mwstSaetze = FIBU_MWST_SAETZE;

    /** UI-Hilfsobjekte je Positionszeile (Autocomplete) */
    positionArtikel: Material[] = [];
    positionFahrzeuge: any[] = [];
    positionHonorarTas: any[] = [];
    positionTieraerzte: Tierarzt[] = [];

    /** Wie Review: Positionen ausblenden, nur Gesamtbetrag speichern. */
    nurGesamtbetrag = false;
    gesamtNetto = 0;
    gesamtMwstEuro = 0;
    /** MwSt-% für Gesamtbetrag-Modus (wie Positionszeile). */
    gesamtMwstsatz = 19;
    gesamtBezeichnung = '';
    gesamtArtikel: Material = null;
    gesamtFahrzeug: any = null;
    gesamtHonorarTa: any = null;
    gesamtSachkonto: string = null;
    gesamtKostenstelleSuffix: string = null;
    gesamtKennzeichen: string = null;
    gesamtKontoNr: string = null;
    gesamtFibuAufwandKontoId: number = null;
    gesamtTierarzt: Tierarzt = null;
    private positionenVorGesamt: GemeinkostenPosition[] | null = null;
    private artikelVorGesamt: Material[] | null = null;
    private fahrzeugeVorGesamt: any[] | null = null;
    private tieraerzteVorGesamt: Tierarzt[] | null = null;

    constructor(
        public dialogRef: MatDialogRef<GemeinkostenDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly http: HttpClient,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        private readonly dialog: MatDialog,
    ) {
        if (data?.gemeinkosten) {
            this.gemeinkosten = data.gemeinkosten;
        }
        if (data?.nurHonorar) {
            this.nurHonorar = this.data.nurHonorar;
            this.artikelParams = new HttpParams().set('honorar', '1');
        } else {
            this.artikelParams = new HttpParams().set('nebenkosten', '1');
            this.artikelParams = this.artikelParams.set('honorar', '0');
        }
    }

    setDates() {
        if (!this.leistungsdatumVonCtrl.value) {
            this.leistungsdatumVonCtrl.setValue(this.datumCtrl.value);
        }
        if (!this.leistungsdatumBisCtrl.value) {
            this.leistungsdatumBisCtrl.setValue(this.datumCtrl.value);
        }
    }

    ngOnInit(): void {
        if (this.gemeinkosten.kosten_id) {
            this.material = <Material>{
                artikel_id: this.gemeinkosten.artikel_id,
                artikel_me: this.gemeinkosten.artikel_me,
            };
            this.gemeinkostenTypCtrl.setValue(
                this.gemeinkosten.tierarzt_id ? 2 : Number(this.gemeinkosten.allgemein) > 0 ? 0 : Number(this.gemeinkosten.labor) > 0 ? 1 : 0,
            );
            this.kommentarCtrl.setValue(this.gemeinkosten.kommentar);
            this.rechnungNummerCtrl.setValue(this.gemeinkosten.rechnung_nr);
            this.datumCtrl.setValue(this.gemeinkosten.datum);
            this.leistungsdatumVonCtrl.setValue(this.gemeinkosten.leistungsdatum_von, { emitEvent: false });
            this.leistungsdatumBisCtrl.setValue(this.gemeinkosten.leistungsdatum_bis);
            this.tierarzt = this.createTierarztObject(this.gemeinkosten);
            if (this.gemeinkosten.lieferant_id) {
                this.supplier = <Supplier>{
                    lieferant_id: this.gemeinkosten.lieferant_id,
                    bezeichnung: this.gemeinkosten.lieferant,
                };
            }
        }

        this.initPositionen();
        this.hydrateSupplierFibu(() =>
            this.gemeinkosten.positionen.forEach((_, i) => this.resolveAufwandKonto(i)),
        );
    }

    private initPositionen() {
        if (!this.gemeinkosten.positionen) {
            this.gemeinkosten.positionen = [];
        }
        if (this.gemeinkosten.positionen.length === 0 && this.gemeinkosten.preise?.length > 0) {
            this.gemeinkosten.positionen = this.gemeinkosten.preise.map(p => {
                const pos = new GemeinkostenPosition();
                pos.kosten_netto = p.kosten_netto;
                pos.mwstsatz = normalizeMwstSatz(p.mwstsatz);
                pos.artikel_id = this.gemeinkosten.artikel_id;
                pos.artikel_me = this.gemeinkosten.artikel_me;
                pos.verteilungsart = this.defaultVerteilungsart();
                if (pos.verteilungsart === 'TIERARZT' && this.gemeinkosten.tierarzt_id) {
                    pos.tierarzt_id = this.gemeinkosten.tierarzt_id;
                    pos.tierarzt = this.gemeinkosten.tierarzt;
                }
                return pos;
            });
        }
        if (this.gemeinkosten.positionen.length === 0) {
            this.gemeinkosten.positionen.push(this.newPosition());
        }
        this.gemeinkosten.positionen.forEach(p => {
            p.mwstsatz = normalizeMwstSatz(p.mwstsatz);
            const n = Number(p.kosten_netto);
            if (Number.isFinite(n) && n < 0) {
                p.kosten_netto = Math.abs(n);
                p.buchungsseite = 'H';
            } else if (p.buchungsseite !== 'H') {
                p.buchungsseite = 'S';
            }
        });
        this.positionArtikel = this.gemeinkosten.positionen.map(p =>
            p.artikel_id
                ? <Material>{ artikel_id: p.artikel_id, artikel_me: p.artikel_me || '' }
                : null,
        );
        this.positionFahrzeuge = this.gemeinkosten.positionen.map(p =>
            p.fibu_fahrzeug_id
                ? {
                      fibu_fahrzeug_id: p.fibu_fahrzeug_id,
                      kennzeichen: p.kennzeichen,
                      bezeichnung: p.fahrzeug_bezeichnung,
                      anzeige:
                          (p.kennzeichen || '') +
                          (p.fahrzeug_bezeichnung ? ' · ' + p.fahrzeug_bezeichnung : ''),
                      // Nicht Positions-Suffix als Haupt-Suffix missbrauchen – Map nachladen
                      kostenstelle_suffix: null,
                      tierarzt_id: p.tierarzt_id,
                  }
                : null,
        );
        this.positionFahrzeuge.forEach((_, i) => this.hydrateFahrzeugKostenarten(i));
        this.positionHonorarTas = this.gemeinkosten.positionen.map(p =>
            p.fibu_honorar_ta_id
                ? {
                      fibu_honorar_ta_id: p.fibu_honorar_ta_id,
                      bezeichnung: p.honorar_ta_bezeichnung,
                      anzeige: p.honorar_ta_bezeichnung || `Honorar-TA #${p.fibu_honorar_ta_id}`,
                      kostenstelle_suffix: null,
                      tierarzt_id: p.tierarzt_id,
                  }
                : null,
        );
        this.positionHonorarTas.forEach((_, i) => this.hydrateHonorarKostenarten(i));
        this.positionTieraerzte = this.gemeinkosten.positionen.map(p => {
            if (!p.tierarzt_id) {
                return null;
            }
            const v = new Tierarzt();
            v.tierarzt_id = p.tierarzt_id;
            v.nachname = p.tierarzt || '';
            v.vorname = '';
            v.titel = '';
            return v;
        });
        const fzMitTa = this.positionFahrzeuge.find(f => f?.tierarzt_id);
        if (fzMitTa) {
            this.syncKopfTierarztFromFahrzeug(fzMitTa);
        }
    }

    private defaultVerteilungsart(): GemeinkostenPosition['verteilungsart'] {
        if (this.gemeinkostenTypCtrl.value === 1) {
            return 'LABOR';
        }
        if (this.gemeinkostenTypCtrl.value === 2) {
            return 'TIERARZT';
        }
        return 'ALLGEMEIN';
    }

    newPosition(): GemeinkostenPosition {
        const pos = new GemeinkostenPosition();
        pos.verteilungsart = this.defaultVerteilungsart();
        pos.mwstsatz = 19;
        if (this.material?.artikel_id) {
            pos.artikel_id = this.material.artikel_id;
            pos.artikel_me = this.material.artikel_me;
        }
        if (pos.verteilungsart === 'TIERARZT' && this.tierarzt?.tierarzt_id) {
            pos.tierarzt_id = this.tierarzt.tierarzt_id;
        }
        return pos;
    }

    createTierarztObject(g: Gemeinkosten) {
        let vet = new Tierarzt();
        vet.tierarzt_id = g.tierarzt_id;
        vet.nachname = g.tierarzt;
        vet.vorname = '';
        vet.titel = '';
        return vet;
    }

    setMaterial(m: Material) {
        this.material = m;
        // Standard-Artikel auf Positionen ohne eigenen Artikel übernehmen
        if (m?.artikel_id && this.gemeinkosten.positionen) {
            this.gemeinkosten.positionen.forEach((p, i) => {
                if (!p.artikel_id) {
                    p.artikel_id = m.artikel_id;
                    p.artikel_me = m.artikel_me;
                    p.artikel_buchungskonto = (m as any).buchungskonto || null;
                    this.positionArtikel[i] = m;
                    this.resolveAufwandKonto(i);
                }
            });
            this.positionArtikel = [...this.positionArtikel];
        }
    }

    openStandardArtikelPicker(): void {
        const initial = (this.material?.artikel_me || '').trim();
        this.dialog
            .open(NebenkostenArtikelPickerDialogComponent, {
                width: '640px',
                maxWidth: '96vw',
                data: { initialSearch: initial, honorar: this.nurHonorar },
            })
            .afterClosed()
            .subscribe((m: Material | null) => {
                if (m) {
                    this.setMaterial(m);
                }
            });
    }

    openPositionArtikelPicker(i: number): void {
        const initial =
            (this.gemeinkosten.positionen[i]?.bezeichnung || '').trim() ||
            (this.positionArtikel[i]?.artikel_me || '').trim() ||
            '';
        this.dialog
            .open(NebenkostenArtikelPickerDialogComponent, {
                width: '640px',
                maxWidth: '96vw',
                data: { initialSearch: initial, honorar: this.nurHonorar },
            })
            .afterClosed()
            .subscribe((m: Material | null) => {
                if (m) {
                    this.setPositionArtikel(i, m);
                }
            });
    }

    openGesamtArtikelPicker(): void {
        const initial =
            (this.gesamtBezeichnung || '').trim() ||
            (this.gesamtArtikel?.artikel_me || '').trim() ||
            '';
        this.dialog
            .open(NebenkostenArtikelPickerDialogComponent, {
                width: '640px',
                maxWidth: '96vw',
                data: { initialSearch: initial, honorar: this.nurHonorar },
            })
            .afterClosed()
            .subscribe((m: Material | null) => {
                if (m) {
                    this.setGesamtArtikel(m);
                }
            });
    }

    setPositionArtikel(i: number, m: Material) {
        this.positionArtikel[i] = m;
        const p = this.gemeinkosten.positionen[i];
        p.artikel_id = m?.artikel_id ?? null;
        p.artikel_me = m?.artikel_me ?? null;
        p.artikel_buchungskonto = (m as any)?.buchungskonto || null;
        if (m?.artikel_me && !(p.bezeichnung || '').trim()) {
            p.bezeichnung = m.artikel_me;
        }
        const kfzArt = kfzSachkontoFromArtikel(p.artikel_buchungskonto);
        if (p.fibu_fahrzeug_id && kfzArt) {
            p.sachkonto = kfzArt;
            const f = this.positionFahrzeuge?.[i];
            if (f) {
                p.kostenstelle_suffix = kfzSuffixForFahrzeug(f, p.sachkonto);
            }
        }
        this.resolveAufwandKonto(i);
    }

    setLieferant(s: Supplier) {
        this.supplier = s;
        this.gemeinkosten.positionen.forEach((_, i) => this.resolveAufwandKonto(i));
    }

    /** Lieferant oft nur id+Name – Gegenkonto (z. B. 4945.01) nachladen. */
    private hydrateSupplierFibu(done?: () => void) {
        const id = this.supplier?.lieferant_id;
        if (!id) {
            done?.();
            return;
        }
        if (this.supplier?.buchungsgegenkonto) {
            done?.();
            return;
        }
        this.api
            .get(this.apiBaseUrl + 'lieferant/read_one.php', new HttpParams().set('lieferant_id', String(id)))
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res;
                    if (rec?.lieferant_id) {
                        this.supplier = Object.assign({} as Supplier, this.supplier, {
                            lieferant_id: rec.lieferant_id,
                            bezeichnung: rec.bezeichnung || this.supplier?.bezeichnung,
                            buchungskonto: rec.buchungskonto,
                            buchungsgegenkonto: rec.buchungsgegenkonto,
                        });
                    }
                    done?.();
                },
                error: () => done?.(),
            });
    }

    setTierarzt(v: Tierarzt) {
        this.tierarzt = v;
        if (this.nurHonorar && v?.tierarzt_id) {
            this.lookupHonorarTaByTierarzt(v.tierarzt_id, ta => {
                if (!ta) {
                    return;
                }
                this.gemeinkosten.positionen.forEach((_, i) => this.setPositionHonorarTa(i, ta));
                this.setGesamtHonorarTa(ta);
            });
        }
    }

    onTypChanged() {
        const art = this.defaultVerteilungsart();
        this.gemeinkosten.positionen.forEach((p, i) => {
            if (p.verteilungsart !== 'FAHRZEUG_TA') {
                p.verteilungsart = art;
                if (art === 'TIERARZT' && this.tierarzt?.tierarzt_id) {
                    p.tierarzt_id = this.tierarzt.tierarzt_id;
                    this.positionTieraerzte[i] = this.tierarzt;
                }
            }
        });
    }

    setPositionFahrzeug(i: number, f: any) {
        this.positionFahrzeuge[i] = f;
        const p = this.gemeinkosten.positionen[i];
        if (!f) {
            p.fibu_fahrzeug_id = null;
            p.kennzeichen = null;
            p.kostenstelle_suffix = null;
            p.sachkonto = null;
            if (p.verteilungsart === 'FAHRZEUG_TA') {
                p.verteilungsart = this.defaultVerteilungsart();
            }
            this.resolveAufwandKonto(i);
            return;
        }
        p.fibu_fahrzeug_id = f.fibu_fahrzeug_id;
        p.kennzeichen = f.kennzeichen;
        p.verteilungsart = 'FAHRZEUG_TA';
        // Default Kostenart aus Artikel (z. B. 4580 Connectivity), sonst Betrieb 4530
        if (!p.sachkonto) {
            p.sachkonto = defaultKfzSachkonto(
                p.artikel_buchungskonto || (this.positionArtikel[i] as any)?.buchungskonto,
            );
        }
        this.withFahrzeugKostenarten(i, full => {
            const fz = full || f;
            p.kostenstelle_suffix = kfzSuffixForFahrzeug(fz, p.sachkonto);
            // TA nur vom Fahrzeug übernehmen – nie erfinden (Hof/ZBV → leer = ohne VetVet-KST)
            if (fz.tierarzt_id) {
                p.tierarzt_id = fz.tierarzt_id;
                p.tierarzt = (fz.tierarzt || '').trim();
                const v = new Tierarzt();
                v.tierarzt_id = fz.tierarzt_id;
                v.titel = fz.tierarzt_titel || '';
                v.vorname = fz.tierarzt_vorname || '';
                v.nachname = fz.tierarzt_nachname || p.tierarzt || '';
                this.positionTieraerzte[i] = v;
                this.positionTieraerzte = [...this.positionTieraerzte];
                this.syncKopfTierarztFromFahrzeug(fz);
            } else {
                p.tierarzt_id = null;
                p.tierarzt = null;
                this.positionTieraerzte[i] = null;
                this.positionTieraerzte = [...this.positionTieraerzte];
            }
            this.resolveAufwandKonto(i);
        });
    }

    /**
     * Kopf „Tierarzt“ + TA für Legacy-Statistik (kosten.tierarzt_id),
     * wenn Fahrzeug eine Kostenstelle/TA hat. Hof ohne TA → Kopf unverändert.
     */
    private syncKopfTierarztFromFahrzeug(f: any) {
        if (!f?.tierarzt_id) {
            return;
        }
        this.tierarzt = Object.assign(new Tierarzt(), {
            tierarzt_id: f.tierarzt_id,
            titel: f.tierarzt_titel || '',
            vorname: f.tierarzt_vorname || '',
            nachname: f.tierarzt_nachname || (f.tierarzt || '').trim(),
        });
        this.gemeinkostenTypCtrl.setValue(2, { emitEvent: false });
    }

    setPositionTierarzt(i: number, v: Tierarzt) {
        this.positionTieraerzte[i] = v;
        const p = this.gemeinkosten.positionen[i];
        p.tierarzt_id = v?.tierarzt_id ?? null;
        p.tierarzt = v ? `${v.titel || ''}${v.vorname || ''} ${v.nachname || ''}`.trim() : null;
        if (this.nurHonorar && v?.tierarzt_id) {
            this.lookupHonorarTaByTierarzt(v.tierarzt_id, ta => this.setPositionHonorarTa(i, ta));
        }
    }

    setPositionHonorarTa(i: number, ta: any) {
        this.positionHonorarTas[i] = ta;
        const p = this.gemeinkosten.positionen[i];
        if (!ta) {
            p.fibu_honorar_ta_id = null;
            p.kostenstelle_suffix = null;
            if (p.sachkonto === '4780' || p.sachkonto === '4760') {
                p.sachkonto = null;
            }
            this.resolveAufwandKonto(i);
            return;
        }
        p.fibu_honorar_ta_id = ta.fibu_honorar_ta_id;
        p.verteilungsart = 'TIERARZT';
        if (!p.sachkonto) {
            p.sachkonto = '4780';
        }
        this.withHonorarKostenarten(i, full => {
            const rec = full || ta;
            p.kostenstelle_suffix = kfzSuffixForFahrzeug(rec, p.sachkonto);
            if (rec.tierarzt_id) {
                p.tierarzt_id = rec.tierarzt_id;
                p.tierarzt = (rec.tierarzt || '').trim();
                const v = new Tierarzt();
                v.tierarzt_id = rec.tierarzt_id;
                v.titel = rec.tierarzt_titel || '';
                v.vorname = rec.tierarzt_vorname || '';
                v.nachname = rec.tierarzt_nachname || p.tierarzt || '';
                this.positionTieraerzte[i] = v;
                this.positionTieraerzte = [...this.positionTieraerzte];
                this.syncKopfTierarztFromFahrzeug(rec);
            }
            this.resolveAufwandKonto(i);
        });
    }

    onKostenartChanged(i: number) {
        const p = this.gemeinkosten.positionen[i];
        if (p.fibu_fahrzeug_id && p.sachkonto) {
            p.verteilungsart = 'FAHRZEUG_TA';
            this.withFahrzeugKostenarten(i, f => {
                if (f) {
                    p.kostenstelle_suffix = kfzSuffixForFahrzeug(f, p.sachkonto);
                }
                this.resolveAufwandKonto(i);
            });
            return;
        }
        if (p.fibu_honorar_ta_id && p.sachkonto) {
            p.verteilungsart = 'TIERARZT';
            this.withHonorarKostenarten(i, ta => {
                if (ta) {
                    p.kostenstelle_suffix = kfzSuffixForFahrzeug(ta, p.sachkonto);
                }
                this.resolveAufwandKonto(i);
            });
            return;
        }
        this.resolveAufwandKonto(i);
    }

    /** Lädt kostenarten_map vom Fahrzeug-Stamm nach, falls beim Edit nur Stub vorhanden. */
    private hydrateFahrzeugKostenarten(i: number, done?: (f: any) => void) {
        this.withFahrzeugKostenarten(i, done);
    }

    private withFahrzeugKostenarten(i: number, done?: (f: any) => void) {
        const f = this.positionFahrzeuge?.[i];
        if (!f?.fibu_fahrzeug_id) {
            done?.(null);
            return;
        }
        if (f.kostenarten_map !== undefined || Array.isArray(f.kostenarten)) {
            done?.(f);
            return;
        }
        this.api
            .get(
                this.apiBaseUrl + 'fibu_fahrzeug/read_one.php',
                new HttpParams().set('fibu_fahrzeug_id', String(f.fibu_fahrzeug_id)),
            )
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res;
                    if (rec?.fibu_fahrzeug_id) {
                        this.positionFahrzeuge[i] = Object.assign({}, f, rec, {
                            kostenarten_map: rec.kostenarten_map ?? '',
                        });
                        this.positionFahrzeuge = [...this.positionFahrzeuge];
                    }
                    done?.(this.positionFahrzeuge[i]);
                },
                error: () => done?.(f),
            });
    }

    private hydrateHonorarKostenarten(i: number, done?: (f: any) => void) {
        this.withHonorarKostenarten(i, done);
    }

    private withHonorarKostenarten(i: number, done?: (f: any) => void) {
        const f = this.positionHonorarTas?.[i];
        if (!f?.fibu_honorar_ta_id) {
            done?.(null);
            return;
        }
        if (f.kostenarten_map !== undefined || Array.isArray(f.kostenarten)) {
            done?.(f);
            return;
        }
        this.api
            .get(
                this.apiBaseUrl + 'fibu_honorar_ta/read_one.php',
                new HttpParams().set('fibu_honorar_ta_id', String(f.fibu_honorar_ta_id)),
            )
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res;
                    if (rec?.fibu_honorar_ta_id) {
                        this.positionHonorarTas[i] = Object.assign({}, f, rec, {
                            kostenarten_map: rec.kostenarten_map ?? '',
                        });
                        this.positionHonorarTas = [...this.positionHonorarTas];
                    }
                    done?.(this.positionHonorarTas[i]);
                },
                error: () => done?.(f),
            });
    }

    private lookupHonorarTaByTierarzt(tierarztId: number, done: (ta: any) => void) {
        this.api
            .get(
                this.apiBaseUrl + 'fibu_honorar_ta/read.php',
                new HttpParams().set('tierarzt_id', String(tierarztId)).set('aktiv', '1').set('limit', '1'),
            )
            .subscribe({
                next: (res: any) => done((res?.records || [])[0] || null),
                error: () => done(null),
            });
    }

    private withGesamtFahrzeugKostenarten(done?: (f: any) => void) {
        const f = this.gesamtFahrzeug;
        if (!f?.fibu_fahrzeug_id) {
            done?.(null);
            return;
        }
        if (f.kostenarten_map !== undefined || Array.isArray(f.kostenarten)) {
            done?.(f);
            return;
        }
        this.api
            .get(
                this.apiBaseUrl + 'fibu_fahrzeug/read_one.php',
                new HttpParams().set('fibu_fahrzeug_id', String(f.fibu_fahrzeug_id)),
            )
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res;
                    if (rec?.fibu_fahrzeug_id) {
                        this.gesamtFahrzeug = Object.assign({}, f, rec, {
                            kostenarten_map: rec.kostenarten_map ?? '',
                        });
                    }
                    done?.(this.gesamtFahrzeug);
                },
                error: () => done?.(f),
            });
    }

    resolveAufwandKonto(i: number) {
        if (this.supplier?.lieferant_id && !this.supplier?.buchungsgegenkonto) {
            this.hydrateSupplierFibu(() => this.resolveAufwandKontoAfterSupplier(i));
            return;
        }
        this.resolveAufwandKontoAfterSupplier(i);
    }

    /**
     * Aufwandskonto: 1) Fahrzeug+Kostenart (Kfz), sonst 2) Artikel (+ Reinigung → 4250.01 / Lieferant .02).
     * Kreditor kommt weiterhin vom Lieferanten (nicht Artikel.buchungsgegenkonto=1600).
     */
    private resolveAufwandKontoAfterSupplier(i: number) {
        const p = this.gemeinkosten.positionen[i];
        p.konto_nr = null;
        p.fibu_aufwand_konto_id = null;

        if ((p.fibu_fahrzeug_id || p.fibu_honorar_ta_id) && p.sachkonto && p.kostenstelle_suffix) {
            const expected = kfzKontoNr(p.sachkonto, p.kostenstelle_suffix);
            p.konto_nr = expected;
            const params = new HttpParams()
                .set('sachkonto', String(p.sachkonto).trim())
                .set('kostenstelle_suffix', String(p.kostenstelle_suffix).trim())
                .set('aktiv', '1')
                .set('limit', '1');
            this.api.get(this.apiBaseUrl + 'fibu_konto/read.php', params).subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res?.[0];
                    if (rec) {
                        p.fibu_aufwand_konto_id = rec.fibu_konto_id;
                        p.konto_nr = rec.konto_nr;
                        return;
                    }
                    if (!expected) {
                        return;
                    }
                    this.api
                        .get(
                            this.apiBaseUrl + 'fibu_konto/read.php',
                            new HttpParams().set('search', expected).set('aktiv', '1').set('limit', '5'),
                        )
                        .subscribe({
                            next: (res2: any) => {
                                const hit = (res2?.records || []).find((r: any) => r.konto_nr === expected);
                                if (hit) {
                                    p.fibu_aufwand_konto_id = hit.fibu_konto_id;
                                    p.konto_nr = hit.konto_nr;
                                }
                            },
                        });
                },
            });
            return;
        }

        const kontoNr = preferredAufwandKontoNr({
            artikelBuchungskonto: p.artikel_buchungskonto || (this.positionArtikel[i] as any)?.buchungskonto,
            lieferantGegenkonto: this.supplier?.buchungsgegenkonto,
        });
        if (!kontoNr) {
            return;
        }
        // exakte konto_nr, Fallback Stamm ohne Suffix
        const params = new HttpParams().set('aktiv', '1').set('limit', '5');
        this.api.get(this.apiBaseUrl + 'fibu_konto/read.php', params.set('search', kontoNr)).subscribe({
            next: (res: any) => {
                const records: any[] = res?.records || [];
                const exact =
                    records.find(r => r.konto_nr === kontoNr) ||
                    records.find(r => r.sachkonto === kontoNr && !r.kostenstelle_suffix);
                if (exact) {
                    p.fibu_aufwand_konto_id = exact.fibu_konto_id;
                    p.konto_nr = exact.konto_nr;
                    return;
                }
                // gezielter Filter sachkonto
                this.api
                    .get(
                        this.apiBaseUrl + 'fibu_konto/read.php',
                        new HttpParams().set('sachkonto', kontoNr.split('.')[0]).set('aktiv', '1').set('limit', '20'),
                    )
                    .subscribe({
                        next: (res2: any) => {
                            const list: any[] = res2?.records || [];
                            const base = kontoNr.split('.')[0];
                            const hit =
                                list.find(r => r.konto_nr === kontoNr) ||
                                list.find(r => r.konto_nr === `${base}.00`) ||
                                list.find(
                                    r =>
                                        r.sachkonto === base &&
                                        (r.kostenstelle_suffix == null ||
                                            r.kostenstelle_suffix === '' ||
                                            String(r.kostenstelle_suffix) === '00'),
                                );
                            if (hit) {
                                p.fibu_aufwand_konto_id = hit.fibu_konto_id;
                                p.konto_nr = hit.konto_nr;
                            } else {
                                p.konto_nr = kontoNr;
                            }
                        },
                    });
            },
        });
    }

    close() {
        this.dialogRef.close();
    }

    handleFiles(event: any) {
        const files = event.target.files;
        this.filesToUpload.push(files.item(0));
        this.filesProgressValues[0] = 0;
    }

    private buildPositionenPayload(): any[] {
        if (this.nurGesamtbetrag) {
            return [
                {
                    position: 1,
                    bezeichnung:
                        (this.gesamtBezeichnung || '').trim() ||
                        (this.kommentarCtrl.value || '').trim() ||
                        this.buildLeistungsFreitext(),
                    artikel_id: this.gesamtArtikel?.artikel_id || null,
                    kosten_netto: Number(this.gesamtNetto) || 0,
                    mwstsatz: this.gesamtMwstSatz(),
                    verteilungsart: this.gesamtFahrzeug?.fibu_fahrzeug_id
                        ? 'FAHRZEUG_TA'
                        : this.gesamtHonorarTa?.fibu_honorar_ta_id
                          ? 'TIERARZT'
                          : this.defaultVerteilungsart(),
                    fibu_fahrzeug_id: this.gesamtFahrzeug?.fibu_fahrzeug_id || null,
                    fibu_honorar_ta_id: this.gesamtHonorarTa?.fibu_honorar_ta_id || null,
                    sachkonto: this.gesamtSachkonto || null,
                    fibu_aufwand_konto_id: this.gesamtFibuAufwandKontoId || null,
                    tierarzt_id: this.gesamtTierarzt?.tierarzt_id || null,
                },
            ];
        }
        return this.gemeinkosten.positionen.map((p, idx) => ({
            position: idx + 1,
            bezeichnung: (p.bezeichnung || '').trim() || null,
            artikel_id: p.artikel_id || null,
            kosten_netto: Math.abs(Number(p.kosten_netto) || 0),
            buchungsseite: p.buchungsseite === 'H' ? 'H' : 'S',
            mwstsatz: p.mwstsatz,
            verteilungsart: p.fibu_fahrzeug_id
                ? 'FAHRZEUG_TA'
                : p.fibu_honorar_ta_id
                  ? 'TIERARZT'
                  : p.verteilungsart || this.defaultVerteilungsart(),
            fibu_fahrzeug_id: p.fibu_fahrzeug_id || null,
            fibu_honorar_ta_id: p.fibu_honorar_ta_id || null,
            sachkonto: p.sachkonto || null,
            fibu_aufwand_konto_id: p.fibu_aufwand_konto_id || null,
            tierarzt_id: p.tierarzt_id || null,
        }));
    }

    toggleBuchungsseite(i: number): void {
        const p = this.gemeinkosten.positionen[i];
        if (!p) {
            return;
        }
        p.buchungsseite = p.buchungsseite === 'H' ? 'S' : 'H';
    }

    /** Kopf-Artikel für Legacy kosten_update: erste Positions-Artikel-ID oder Standard. */
    private resolveKopfArtikelId(): number {
        if (this.nurGesamtbetrag) {
            return this.gesamtArtikel?.artikel_id || this.material?.artikel_id || null;
        }
        const fromPos = this.gemeinkosten.positionen.find(p => p.artikel_id)?.artikel_id;
        return fromPos || this.material?.artikel_id || null;
    }

    private buildPreiseFromPositionen(): GemeinkostenPreise[] {
        return this.buildPositionenPayload().map(p => {
            const preis = new GemeinkostenPreise();
            const n = Math.abs(Number(p.kosten_netto) || 0);
            preis.kosten_netto = p.buchungsseite === 'H' ? -n : n;
            preis.mwstsatz = normalizeMwstSatz(Number(p.mwstsatz));
            return preis;
        });
    }

    uploadFilesToServer() {
        let fd = new FormData();
        let fileName = '';

        fd.set('labor', null);
        fd.set('allgemein', null);
        fd.set('tierarzt_id', null);

        if (this.gemeinkosten && this.gemeinkosten.kosten_id) {
            fd.append('kosten_id', this.gemeinkosten.kosten_id.toString());
        }

        if (this.supplier) {
            fd.append('lieferant_id', this.supplier?.lieferant_id?.toString());
        }

        if (this.tierarzt && this.gemeinkostenTypCtrl.value === 2) {
            fd.set('tierarzt_id', this.tierarzt.tierarzt_id.toString());
        }
        if (this.gemeinkostenTypCtrl.value === 0) {
            fd.set('allgemein', '1');
        }

        if (this.gemeinkostenTypCtrl.value === 1) {
            fd.set('labor', '1');
        }

        const kopfArtikelId = this.resolveKopfArtikelId();
        if (kopfArtikelId) {
            fd.append('artikel_id', kopfArtikelId.toString());
        }

        fd.append('kommentar', this.kommentarCtrl.value);
        fd.append('rechnung_nr', this.rechnungNummerCtrl.value);
        const positionen = this.buildPositionenPayload();
        fd.append('positionen', JSON.stringify(positionen));
        fd.append('preise', JSON.stringify(this.buildPreiseFromPositionen()));
        fd.append('freigegeben', this.gemeinkosten?.freigegeben?.toString());

        if (this.datumCtrl.value) {
            const d: Date = new Date(this.datumCtrl.value);
            fd.append('datum', d.toISOString());
        }

        if (this.leistungsdatumVonCtrl.value) {
            const lv: Date = new Date(this.leistungsdatumVonCtrl.value);
            fd.append('leistungsdatum_von', lv.toISOString());
        }

        if (this.leistungsdatumBisCtrl.value) {
            const lb = new Date(this.leistungsdatumBisCtrl.value);
            fd.append('leistungsdatum_bis', lb.toISOString());
        }

        for (var i = 0; i < this.filesToUpload.length; i++) {
            let fileNumber = i;
            let file = this.filesToUpload[fileNumber];

            fd.append('dokument', file);
            fileName = file.name;
        }
        let params = new HttpParams();

        const options = { headers: new HttpHeaders('Phito-Type: fileupload'), params: params, reportProgress: true };

        this.http.post<any>(this.apiBaseUrl + 'kosten/update.php', fd, options).subscribe(
            event => {
                if (event.type == HttpEventType.UploadProgress) {
                    let percentDone = Math.round((100 * event.loaded) / event.total);
                    this.filesProgressValues[0] = percentDone;
                } else if (event instanceof HttpResponse) {
                    // done
                }
            },

            error => {
                this.filesUploadStatus[0] = 2;
                this.messageService.errorMessage('Fehler', error);
                this.markFileAsFailed(0);
            },
            () => {
                if (this.filesToUpload.length > 0) {
                    this.markFileAsUploaded(0);
                    this.messageService.infoMessage(fileName + ' erfolgreich hochgeladen!');
                }
                this.close();
            },
        );
    }

    markFileAsFailed(no: number) {
        this.filesUploadStatus[no] = 2;
        this.checkShowCloseButton();
    }

    markFileAsUploaded(no: number) {
        this.filesUploadStatus[no] = 1;
        this.checkShowCloseButton();
    }

    checkShowCloseButton() {
        var show: boolean = true;
        for (var i = 0; i < this.filesUploadStatus.length; i++) {
            if (this.filesUploadStatus[i] == 0) {
                show = false;
            }
        }
    }

    save() {
        this.uploadFilesToServer();
    }

    openFileSelector() {
        this.fileSelector.nativeElement.click();
    }

    get sumNetto(): number {
        if (this.nurGesamtbetrag) {
            return Number(this.gesamtNetto) || 0;
        }
        return (this.gemeinkosten.positionen || []).reduce((s, p) => s + (Number(p.kosten_netto) || 0), 0);
    }

    get sumMwst(): number {
        if (this.nurGesamtbetrag) {
            return Number(this.gesamtMwstEuro) || 0;
        }
        return (this.gemeinkosten.positionen || []).reduce((s, p) => {
            const netto = Number(p.kosten_netto) || 0;
            const satz = Number(p.mwstsatz) || 0;
            return s + (netto * satz) / 100;
        }, 0);
    }

    get sumBrutto(): number {
        return this.sumNetto + this.sumMwst;
    }

    get gesamtBrutto(): number {
        return roundEuro2((Number(this.gesamtNetto) || 0) + (Number(this.gesamtMwstEuro) || 0));
    }

    onNurGesamtbetragChanged() {
        if (this.nurGesamtbetrag) {
            this.enterGesamtbetragMode();
        } else {
            this.leaveGesamtbetragMode();
        }
    }

    private enterGesamtbetragMode() {
        this.positionenVorGesamt = this.gemeinkosten.positionen.map(p => Object.assign(new GemeinkostenPosition(), p));
        this.artikelVorGesamt = [...this.positionArtikel];
        this.fahrzeugeVorGesamt = [...this.positionFahrzeuge];
        this.tieraerzteVorGesamt = [...this.positionTieraerzte];

        this.gesamtNetto = this.sumNettoFromPositionen();
        this.gesamtMwstEuro = this.sumMwstFromPositionen();
        if (this.gesamtMwstEuro <= 0 && this.gesamtNetto > 0) {
            const satz = this.gemeinkosten.positionen[0]?.mwstsatz ?? 19;
            this.gesamtMwstEuro = Math.round(this.gesamtNetto * satz) / 100;
        }
        this.gesamtMwstsatz = this.gesamtMwstSatzFromEuro();

        const firstWithArt = this.gemeinkosten.positionen.find(p => p.artikel_id);
        this.gesamtArtikel = firstWithArt
            ? ({ artikel_id: firstWithArt.artikel_id, artikel_me: firstWithArt.artikel_me || '' } as Material)
            : this.positionArtikel.find(a => !!a) ?? this.material ?? null;
        this.gesamtBezeichnung = this.buildLeistungsFreitext();

        const firstFz = this.gemeinkosten.positionen.find(p => p.fibu_fahrzeug_id);
        if (firstFz?.fibu_fahrzeug_id) {
            this.gesamtFahrzeug = {
                fibu_fahrzeug_id: firstFz.fibu_fahrzeug_id,
                kennzeichen: firstFz.kennzeichen,
                bezeichnung: firstFz.fahrzeug_bezeichnung,
                anzeige:
                    (firstFz.kennzeichen || '') +
                    (firstFz.fahrzeug_bezeichnung ? ' · ' + firstFz.fahrzeug_bezeichnung : ''),
                kostenstelle_suffix: firstFz.kostenstelle_suffix,
                tierarzt_id: firstFz.tierarzt_id,
            };
            this.gesamtSachkonto = firstFz.sachkonto;
            this.gesamtKostenstelleSuffix = firstFz.kostenstelle_suffix;
            this.gesamtKennzeichen = firstFz.kennzeichen;
            this.gesamtKontoNr = firstFz.konto_nr;
            this.gesamtFibuAufwandKontoId = firstFz.fibu_aufwand_konto_id;
            if (firstFz.tierarzt_id) {
                this.gesamtTierarzt = Object.assign(new Tierarzt(), {
                    tierarzt_id: firstFz.tierarzt_id,
                    nachname: firstFz.tierarzt || '',
                });
            }
        } else {
            this.gesamtFahrzeug = null;
            this.gesamtSachkonto = null;
            this.gesamtKostenstelleSuffix = null;
            this.gesamtKennzeichen = null;
            this.gesamtKontoNr = null;
            this.gesamtFibuAufwandKontoId = null;
            this.gesamtTierarzt = null;
        }
        this.resolveGesamtKonto();
    }

    private leaveGesamtbetragMode() {
        if (this.positionenVorGesamt?.length) {
            this.gemeinkosten.positionen = this.positionenVorGesamt.map(p =>
                Object.assign(new GemeinkostenPosition(), p),
            );
            this.positionArtikel = this.artikelVorGesamt ? [...this.artikelVorGesamt] : [];
            this.positionFahrzeuge = this.fahrzeugeVorGesamt ? [...this.fahrzeugeVorGesamt] : [];
            this.positionTieraerzte = this.tieraerzteVorGesamt ? [...this.tieraerzteVorGesamt] : [];
            this.gemeinkosten.positionen.forEach((_, i) => this.resolveAufwandKonto(i));
        }
        this.positionenVorGesamt = null;
        this.artikelVorGesamt = null;
        this.fahrzeugeVorGesamt = null;
        this.tieraerzteVorGesamt = null;
    }

    private sumNettoFromPositionen(): number {
        return (this.gemeinkosten.positionen || []).reduce((s, p) => s + (Number(p.kosten_netto) || 0), 0);
    }

    private sumMwstFromPositionen(): number {
        return (this.gemeinkosten.positionen || []).reduce((s, p) => {
            const netto = Number(p.kosten_netto) || 0;
            const satz = Number(p.mwstsatz) || 0;
            return s + (netto * satz) / 100;
        }, 0);
    }

    private gesamtMwstSatzFromEuro(): number {
        const netto = Number(this.gesamtNetto) || 0;
        const mwst = Number(this.gesamtMwstEuro) || 0;
        if (netto <= 0) {
            return normalizeMwstSatz(this.gemeinkosten.positionen?.[0]?.mwstsatz ?? 19);
        }
        return normalizeMwstSatz(Math.round((mwst / netto) * 10000) / 100);
    }

    private gesamtMwstSatz(): number {
        return normalizeMwstSatz(this.gesamtMwstsatz);
    }

    onGesamtNettoChanged() {
        this.gesamtMwstEuro = roundEuro2(((Number(this.gesamtNetto) || 0) * this.gesamtMwstsatz) / 100);
    }

    onGesamtMwstsatzChanged() {
        this.onGesamtNettoChanged();
    }

    onGesamtMwstEuroChanged() {
        const netto = Number(this.gesamtNetto) || 0;
        const mwst = Number(this.gesamtMwstEuro) || 0;
        if (netto <= 0) {
            return;
        }
        const implied = Math.round((mwst / netto) * 10000) / 100;
        const snapped = normalizeMwstSatz(Math.round(implied));
        if (Math.abs(implied - snapped) < 0.15) {
            this.gesamtMwstsatz = snapped;
        }
    }

    onGesamtBruttoChanged(brutto: number) {
        this.gesamtMwstEuro = mwstEuroForTargetBrutto(this.gesamtNetto, brutto);
    }

    adjustBruttoCent(deltaCents: number) {
        this.onGesamtBruttoChanged(roundEuro2(this.gesamtBrutto + deltaCents / 100));
    }

    canMwstVomGesamtbetragAbziehen(): boolean {
        const brutto = Number(this.gesamtNetto);
        const mwst = Number(this.gesamtMwstsatz);
        return Number.isFinite(brutto) && brutto !== 0 && Number.isFinite(mwst) && mwst > 0;
    }

    /** Netto-Feld enthält oft Brutto: MwSt herausrechnen. */
    mwstVomGesamtbetragAbziehen() {
        if (!this.canMwstVomGesamtbetragAbziehen()) {
            return;
        }
        const netto = nettoFromBrutto(this.gesamtNetto, this.gesamtMwstsatz);
        if (netto != null) {
            this.gesamtNetto = netto;
            this.onGesamtNettoChanged();
        }
    }

    private buildLeistungsFreitext(): string {
        const fromPositions = (this.gemeinkosten.positionen || [])
            .map(p => (p.bezeichnung || '').trim())
            .filter(t => t && !/^gesamtbetrag$/i.test(t));
        if (fromPositions.length === 1) {
            return fromPositions[0];
        }
        if (fromPositions.length > 1) {
            const joined = fromPositions.slice(0, 3).join('; ');
            return fromPositions.length > 3 ? joined + ' …' : joined;
        }
        const kommentar = (this.kommentarCtrl.value || '').trim();
        if (kommentar && !/^gesamtbetrag$/i.test(kommentar) && !/^sim_fibu_/i.test(kommentar)) {
            return kommentar.length > 80 ? kommentar.slice(0, 79) + '…' : kommentar;
        }
        const artikel = (this.gesamtArtikel?.artikel_me || this.material?.artikel_me || '').trim();
        if (artikel) {
            return artikel;
        }
        const lieferant = (this.supplier?.bezeichnung || '').trim();
        if (lieferant) {
            return `Rechnung ${lieferant}`;
        }
        return 'Nebenkosten';
    }

    setGesamtArtikel(m: Material) {
        this.gesamtArtikel = m;
        if (m?.artikel_me && !(this.gesamtBezeichnung || '').trim()) {
            this.gesamtBezeichnung = m.artikel_me;
        }
        this.resolveGesamtKonto();
    }

    setGesamtFahrzeug(f: any) {
        this.gesamtFahrzeug = f;
        if (!f) {
            this.gesamtKennzeichen = null;
            this.gesamtKostenstelleSuffix = null;
            this.gesamtSachkonto = null;
            this.gesamtTierarzt = null;
            this.resolveGesamtKonto();
            return;
        }
        this.gesamtKennzeichen = f.kennzeichen;
        if (!this.gesamtSachkonto) {
            this.gesamtSachkonto = defaultKfzSachkonto((this.gesamtArtikel as any)?.buchungskonto);
        }
        this.withGesamtFahrzeugKostenarten(full => {
            const fz = full || f;
            this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(fz, this.gesamtSachkonto);
            if (fz.tierarzt_id) {
                this.gesamtTierarzt = Object.assign(new Tierarzt(), {
                    tierarzt_id: fz.tierarzt_id,
                    titel: fz.tierarzt_titel || '',
                    vorname: fz.tierarzt_vorname || '',
                    nachname: fz.tierarzt_nachname || '',
                });
                this.syncKopfTierarztFromFahrzeug(fz);
            } else {
                this.gesamtTierarzt = null;
            }
            this.resolveGesamtKonto();
        });
    }

    setGesamtHonorarTa(ta: any) {
        this.gesamtHonorarTa = ta;
        if (!ta) {
            this.gesamtKostenstelleSuffix = null;
            this.resolveGesamtKonto();
            return;
        }
        if (!this.gesamtSachkonto) {
            this.gesamtSachkonto = '4780';
        }
        this.api
            .get(
                this.apiBaseUrl + 'fibu_honorar_ta/read_one.php',
                new HttpParams().set('fibu_honorar_ta_id', String(ta.fibu_honorar_ta_id)),
            )
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res || ta;
                    this.gesamtHonorarTa = Object.assign({}, ta, rec);
                    this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(this.gesamtHonorarTa, this.gesamtSachkonto);
                    if (rec.tierarzt_id) {
                        this.gesamtTierarzt = Object.assign(new Tierarzt(), {
                            tierarzt_id: rec.tierarzt_id,
                            titel: rec.tierarzt_titel || '',
                            vorname: rec.tierarzt_vorname || '',
                            nachname: rec.tierarzt_nachname || '',
                        });
                        this.syncKopfTierarztFromFahrzeug(rec);
                    }
                    this.resolveGesamtKonto();
                },
                error: () => {
                    this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(ta, this.gesamtSachkonto);
                    this.resolveGesamtKonto();
                },
            });
    }

    setGesamtTierarzt(v: Tierarzt) {
        this.gesamtTierarzt = v;
        if (this.nurHonorar && v?.tierarzt_id) {
            this.lookupHonorarTaByTierarzt(v.tierarzt_id, ta => this.setGesamtHonorarTa(ta));
        }
    }

    onGesamtKostenartChanged() {
        if (this.gesamtHonorarTa?.fibu_honorar_ta_id) {
            this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(this.gesamtHonorarTa, this.gesamtSachkonto);
            this.resolveGesamtKonto();
            return;
        }
        this.withGesamtFahrzeugKostenarten(f => {
            if (f && this.gesamtSachkonto) {
                this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(f, this.gesamtSachkonto);
            }
            this.resolveGesamtKonto();
        });
    }

    private resolveGesamtKonto() {
        this.gesamtKontoNr = null;
        this.gesamtFibuAufwandKontoId = null;
        if (
            (this.gesamtFahrzeug?.fibu_fahrzeug_id || this.gesamtHonorarTa?.fibu_honorar_ta_id) &&
            this.gesamtSachkonto &&
            this.gesamtKostenstelleSuffix
        ) {
            const params = new HttpParams()
                .set('sachkonto', this.gesamtSachkonto)
                .set('kostenstelle_suffix', this.gesamtKostenstelleSuffix)
                .set('aktiv', '1')
                .set('limit', '1');
            this.api.get(this.apiBaseUrl + 'fibu_konto/read.php', params).subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res?.[0];
                    if (rec) {
                        this.gesamtFibuAufwandKontoId = rec.fibu_konto_id;
                        this.gesamtKontoNr = rec.konto_nr;
                    }
                },
            });
            return;
        }
        const kontoNr = (this.gesamtArtikel as any)?.buchungskonto || '';
        // Fallback: Artikel-Stamm via Autocomplete-Objekt hat oft kein buchungskonto – Konto bleibt leer bis Artikel gewählt
        if (!kontoNr) {
            return;
        }
        const params = new HttpParams().set('aktiv', '1').set('limit', '5').set('search', kontoNr);
        this.api.get(this.apiBaseUrl + 'fibu_konto/read.php', params).subscribe({
            next: (res: any) => {
                const list: any[] = res?.records || [];
                const base = list.find(
                    r => r.konto_nr === kontoNr || (!r.kostenstelle_suffix && r.sachkonto === kontoNr),
                );
                if (base) {
                    this.gesamtFibuAufwandKontoId = base.fibu_konto_id;
                    this.gesamtKontoNr = base.konto_nr;
                } else {
                    this.gesamtKontoNr = kontoNr;
                }
            },
        });
    }

    isValid() {
        if (this.gemeinkostenTypCtrl.value === null || this.gemeinkostenTypCtrl.value === undefined) {
            return false;
        }
        if (this.gemeinkostenTypCtrl.value === 2) {
            if (!this.tierarzt) {
                return false;
            }
        }

        if (!this.nurHonorar) {
            if (!this.supplier) {
                return false;
            }
        }

        if (!this.datumCtrl.value) {
            return false;
        }
        if (!this.rechnungNummerCtrl.value) {
            return false;
        }
        if (!this.leistungsdatumVonCtrl.value) {
            return false;
        }
        if (this.nurGesamtbetrag) {
            const hasArtikel = !!this.gesamtArtikel?.artikel_id;
            const hasText = !!(this.gesamtBezeichnung || '').trim() || !!(this.kommentarCtrl.value || '').trim();
            return (hasArtikel || hasText) && Number(this.gesamtNetto) >= 0 && Number(this.gesamtMwstEuro) >= 0;
        }
        if (!this.gemeinkosten.positionen?.length) {
            return false;
        }
        if (!this.resolveKopfArtikelId()) {
            // Legacy-Procedure braucht einen Artikel am Kopf – mind. eine Zeile mit Artikel
            return false;
        }
        for (const p of this.gemeinkosten.positionen) {
            if (p.kosten_netto === null || p.kosten_netto === undefined || p.mwstsatz === null || p.mwstsatz === undefined) {
                return false;
            }
            const hasArtikel = !!p.artikel_id;
            const hasText = !!(p.bezeichnung || '').trim();
            if (!hasArtikel && !hasText) {
                return false;
            }
            if (p.verteilungsart === 'FAHRZEUG_TA' || p.fibu_fahrzeug_id) {
                // Tierarzt optional (Hof ohne TA); Pflicht: Fahrzeug + Kostenart
                if (!p.fibu_fahrzeug_id || !p.sachkonto) {
                    return false;
                }
            }
        }
        return true;
    }

    positionHinzufuegen() {
        const pos = this.newPosition();
        this.gemeinkosten.positionen.push(pos);
        this.positionArtikel.push(
            pos.artikel_id
                ? <Material>{ artikel_id: pos.artikel_id, artikel_me: pos.artikel_me }
                : null,
        );
        this.positionFahrzeuge.push(null);
        this.positionHonorarTas.push(null);
        this.positionTieraerzte.push(
            this.gemeinkostenTypCtrl.value === 2 && this.tierarzt ? this.tierarzt : null,
        );
    }

    positionVerschieben(i: number, delta: number) {
        const j = i + delta;
        if (j < 0 || j >= this.gemeinkosten.positionen.length) {
            return;
        }
        this.swapAt(this.gemeinkosten.positionen, i, j);
        this.swapAt(this.positionArtikel, i, j);
        this.swapAt(this.positionFahrzeuge, i, j);
        this.swapAt(this.positionHonorarTas, i, j);
        this.swapAt(this.positionTieraerzte, i, j);
    }

    positionDropped(event: CdkDragDrop<GemeinkostenPosition[]>) {
        if (event.previousIndex === event.currentIndex) {
            return;
        }
        moveItemInArray(this.gemeinkosten.positionen, event.previousIndex, event.currentIndex);
        moveItemInArray(this.positionArtikel, event.previousIndex, event.currentIndex);
        moveItemInArray(this.positionFahrzeuge, event.previousIndex, event.currentIndex);
        moveItemInArray(this.positionHonorarTas, event.previousIndex, event.currentIndex);
        moveItemInArray(this.positionTieraerzte, event.previousIndex, event.currentIndex);
    }

    private swapAt<T>(arr: T[], i: number, j: number) {
        const tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }

    positionEntfernen(i: number) {
        this.gemeinkosten.positionen.splice(i, 1);
        this.positionArtikel.splice(i, 1);
        this.positionFahrzeuge.splice(i, 1);
        this.positionHonorarTas.splice(i, 1);
        this.positionTieraerzte.splice(i, 1);
    }

    canMwstVomBetragAbziehen(i: number): boolean {
        const pos = this.gemeinkosten.positionen?.[i];
        if (!pos) {
            return false;
        }
        const brutto = Number(pos.kosten_netto);
        const mwst = Number(pos.mwstsatz);
        return Number.isFinite(brutto) && brutto !== 0 && Number.isFinite(mwst) && mwst > 0;
    }

    /** Netto-Feld enthält oft Brutto: MwSt herausrechnen. */
    mwstVomBetragAbziehen(i: number) {
        const pos = this.gemeinkosten.positionen?.[i];
        if (!pos || !this.canMwstVomBetragAbziehen(i)) {
            return;
        }
        const netto = nettoFromBrutto(pos.kosten_netto, pos.mwstsatz);
        if (netto != null) {
            pos.kosten_netto = netto;
        }
    }
}
